(function () {
  'use strict';

  /**
   * EliteVault — resolve REAL Shopify automatic discounts from cart.js.
   * Store Admin configures separate automatic discounts (e.g. Gift Set 25%,
   * Executive Set 30%). This module never invents applied amounts or claims a
   * percentage unless Shopify cart state shows the discount.
   */

  function isEligibleWalletItem(item) {
    if (!item) return false;
    var title = (item.product_title || item.title || '').toLowerCase();
    var type = (item.product_type || '').toLowerCase();
    if (
      title.indexOf('accessory') !== -1 ||
      title.indexOf('strap') !== -1 ||
      title.indexOf('keychain') !== -1
    ) {
      return false;
    }
    return title.indexOf('wallet') !== -1 || type.indexOf('wallet') !== -1;
  }

  function countEligibleWalletUnits(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isEligibleWalletItem(item)) return;
      total += parseInt(item.quantity, 10) || 0;
    });
    return total;
  }

  function getCartVariantIds(cart) {
    var ids = {};
    (cart.items || []).forEach(function (item) {
      ids[item.variant_id] = true;
    });
    return ids;
  }

  function getCartProductQuantities(cart) {
    var qty = {};
    (cart.items || []).forEach(function (item) {
      if (!isEligibleWalletItem(item)) return;
      if (!item.product_id) return;
      var key = String(item.product_id);
      qty[key] = (qty[key] || 0) + (parseInt(item.quantity, 10) || 0);
    });
    return qty;
  }

  function getCartProductIds(cart) {
    var ids = {};
    (cart.items || []).forEach(function (item) {
      if (!isEligibleWalletItem(item)) return;
      if (item.product_id) ids[item.product_id] = true;
    });
    return ids;
  }

  /** Actual Shopify discount cents on one cart line. */
  function getLineShopifyDiscountCents(item) {
    if (!item) return 0;
    var allocated = 0;
    (item.discount_allocations || []).forEach(function (allocation) {
      allocated += parseInt(allocation.amount, 10) || 0;
    });
    if (allocated > 0) return allocated;

    var lineLevel = parseInt(item.line_level_total_discount, 10);
    if (!(lineLevel > 0)) lineLevel = parseInt(item.total_discount, 10) || 0;
    if (lineLevel > 0) return lineLevel;

    var original = parseInt(item.original_line_price, 10) || 0;
    var final = parseInt(item.final_line_price, 10) || 0;
    if (original > final) return original - final;
    return 0;
  }

  function getRawLineSavings(item) {
    return getLineShopifyDiscountCents(item);
  }

  function getEligibleSubtotalCents(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (!isEligibleWalletItem(item)) return;
      var original = parseInt(item.original_line_price, 10);
      if (original > 0) {
        total += original;
        return;
      }
      var unit = parseInt(item.price, 10) || parseInt(item.original_price, 10) || 0;
      total += unit * (parseInt(item.quantity, 10) || 1);
    });
    return total;
  }

  function getDiscountApplicationList(cart) {
    var list = [];
    if (!cart) return list;
    if (Array.isArray(cart.discount_applications)) {
      list = list.concat(cart.discount_applications);
    }
    if (Array.isArray(cart.cart_level_discount_applications)) {
      list = list.concat(cart.cart_level_discount_applications);
    }
    return list;
  }

  function readApplicationPercent(app) {
    if (!app) return 0;
    var valueType = String(app.value_type || app.valueType || '').toLowerCase();
    var value = parseFloat(app.value);
    if (valueType.indexOf('percent') !== -1 && !isNaN(value) && value > 0) {
      return Math.round(value);
    }
    var title = String(app.title || app.description || '');
    var match = title.match(/(\d+)\s*%/);
    if (match) return parseInt(match[1], 10);
    return 0;
  }

  function classifyDiscountTitle(title) {
    var t = String(title || '').toLowerCase();
    if (t.indexOf('executive') !== -1) return 'executive';
    if (t.indexOf('gift') !== -1) return 'gift';
    return 'unknown';
  }

  /**
   * Resolve the REAL Shopify discount for a set of cart lines.
   * Returns applied:false when Shopify has not allocated a discount yet.
   */
  function resolveShopifyDiscountForItems(cart, items) {
    items = Array.isArray(items) ? items : [];
    var amount = 0;
    var saleSubtotal = 0;
    var title = '';
    var pctFromMeta = 0;

    items.forEach(function (item) {
      amount += getLineShopifyDiscountCents(item);
      var original = parseInt(item.original_line_price, 10);
      if (original > 0) {
        saleSubtotal += original;
      } else {
        var unit = parseInt(item.price, 10) || parseInt(item.original_price, 10) || 0;
        saleSubtotal += unit * (parseInt(item.quantity, 10) || 1);
      }

      (item.discount_allocations || []).forEach(function (alloc) {
        var allocTitle = String(
          alloc.discount_application_title || alloc.title || ''
        );
        if (allocTitle) {
          title = title || allocTitle;
          var m = allocTitle.match(/(\d+)\s*%/);
          if (m && !pctFromMeta) pctFromMeta = parseInt(m[1], 10);
        }
      });
    });

    if (
      amount <= 0 &&
      cart &&
      items.length &&
      Array.isArray(cart.items) &&
      items.length === cart.items.length
    ) {
      amount = parseInt(cart.total_discount, 10) || 0;
    }

    getDiscountApplicationList(cart).forEach(function (app) {
      var appTitle = String(app.title || app.description || '');
      var appPct = readApplicationPercent(app);
      var kind = classifyDiscountTitle(appTitle);
      if (kind !== 'unknown' || (!title && appTitle)) {
        title = appTitle || title;
      }
      if (appPct > pctFromMeta) pctFromMeta = appPct;
    });

    var percent = 0;
    if (amount > 0) {
      percent =
        pctFromMeta ||
        (saleSubtotal > 0 ? Math.round((amount / saleSubtotal) * 100) : 0);
    }

    var kind = classifyDiscountTitle(title);
    if (kind === 'unknown' && percent > 0) {
      /* Classification only after Shopify applied a real amount — never from qty alone. */
      if (percent >= 28) kind = 'executive';
      else if (percent >= 20) kind = 'gift';
    }

    return {
      applied: amount > 0,
      amount: amount,
      percent: percent,
      saleSubtotal: saleSubtotal,
      title: title,
      kind: kind
    };
  }

  /** Actual Shopify discount on eligible wallet lines only. */
  function getActualEligibleSavings(cart) {
    var items = (cart.items || []).filter(isEligibleWalletItem);
    var resolved = resolveShopifyDiscountForItems(cart, items);
    if (resolved.amount > 0) return resolved.amount;

    var cartLevel = 0;
    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      cartLevel += parseInt(discount.total_allocated_amount, 10) || 0;
    });
    return cartLevel;
  }

  function getLineSavings(item) {
    return getLineShopifyDiscountCents(item);
  }

  /**
   * offerKind reflects detected Shopify discount when applied.
   * state: none | unlock | available | applied
   *   applied = Shopify cart confirms a discount amount
   *   available = enough wallets for an automatic discount, but Shopify has not applied yet
   */
  function getOfferState(cart) {
    var walletUnits = countEligibleWalletUnits(cart);
    var eligibleItems = (cart.items || []).filter(isEligibleWalletItem);
    var resolved = resolveShopifyDiscountForItems(cart, eligibleItems);

    if (walletUnits < 1) {
      return {
        state: 'none',
        offerKind: 'none',
        walletUnits: 0,
        savings: 0,
        percent: 0,
        title: '',
        kind: 'unknown'
      };
    }

    if (resolved.applied) {
      var offerKind =
        resolved.kind === 'executive'
          ? 'percent_executive'
          : resolved.kind === 'gift'
            ? 'percent_gift'
            : 'percent_applied';
      return {
        state: 'applied',
        offerKind: offerKind,
        walletUnits: walletUnits,
        savings: resolved.amount,
        percent: resolved.percent,
        title: resolved.title,
        kind: resolved.kind
      };
    }

    if (walletUnits === 1) {
      return {
        state: 'unlock',
        offerKind: 'unlock_gift',
        walletUnits: walletUnits,
        savings: 0,
        percent: 0,
        title: '',
        kind: 'unknown'
      };
    }

    return {
      state: 'available',
      offerKind: 'pending_shopify',
      walletUnits: walletUnits,
      savings: 0,
      percent: 0,
      title: '',
      kind: 'unknown'
    };
  }

  function pickRecommendVariant(product, cart) {
    var variants = product.variants || [];
    if (!variants.length && product.variant_id) {
      variants = [{
        variant_id: product.variant_id,
        title: product.variant_title || '',
        price: product.price,
        available: product.available !== false
      }];
    }
    if (!variants.length) return null;

    var inCartVariantId = null;
    (cart.items || []).forEach(function (item) {
      if (!isEligibleWalletItem(item)) return;
      if (String(item.product_id) === String(product.id)) {
        inCartVariantId = item.variant_id;
      }
    });

    if (inCartVariantId) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].variant_id) === String(inCartVariantId) && variants[i].available !== false) {
          return variants[i];
        }
      }
    }

    for (var j = 0; j < variants.length; j++) {
      if (variants[j].available !== false) return variants[j];
    }
    return null;
  }

  function pickCarouselVariant(product, cart) {
    return pickRecommendVariant(product, cart || { items: [] });
  }

  window.EV = window.EV || {};
  window.EV.CartDiscount = {
    isEligibleWalletItem: isEligibleWalletItem,
    countEligibleWalletUnits: countEligibleWalletUnits,
    getCartVariantIds: getCartVariantIds,
    getCartProductIds: getCartProductIds,
    getCartProductQuantities: getCartProductQuantities,
    getLineSavings: getLineSavings,
    getLineShopifyDiscountCents: getLineShopifyDiscountCents,
    getActualEligibleSavings: getActualEligibleSavings,
    getEligibleSubtotalCents: getEligibleSubtotalCents,
    resolveShopifyDiscountForItems: resolveShopifyDiscountForItems,
    getOfferState: getOfferState,
    pickRecommendVariant: pickRecommendVariant,
    pickCarouselVariant: pickCarouselVariant
  };
})();
